module.exports = __webpack_public_path__ + "img/gh.652f369b.png";